import '@/installCompositionApi'
import '@/installFineMq'

import { mount } from '@/mounter'

import SanitasBrandingFilter from './SanitasBrandingFilter'
import SanitasBrandingResults from './SanitasBrandingResults'

mount('employee-branding', {
  SanitasBrandingFilter,
  SanitasBrandingResults,
})
